import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=54ab36f6"
import script from "./textarea.vue?vue&type=script&lang=ts"
export * from "./textarea.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports